import Vue from 'vue';
import './sass/vandeputtemerckxbaby.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart, faCartArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';

library.add(faShoppingCart);
library.add(faCartArrowDown);

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.filter('toCurrency', (value) => {
  const formatter = new Intl.NumberFormat('be-BE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });
  if (typeof value !== 'number') {
    return value;
  }
  return formatter.format(value);
});

new Vue({
  render: (h) => h(App),
}).$mount('#app');
